module.exports = __webpack_public_path__ + "img/apple-pay.86079855.svg";